import Dropdown from 'bootstrap/js/src/dropdown';

// The framework's hover-dropdown JS (nav/index.js handleNavOpenClass()) drives real
// Bootstrap Dropdown state via mouseenter/mouseleave, but only when
// isDesktopBreakpoint(navbar) is true — hover is a desktop-only concept there by
// design. On mobile, touching a secondary-nav dropdown fires a synthetic
// mouseenter/mouseleave in most browsers, but the framework's own handler skips
// acting on it below the desktop breakpoint, so the hover-driven preview never
// appears — only the existing click/tap-to-navigate behavior does, which is left
// untouched here; this only adds the missing show()/hide() trigger alongside it.
export default function () {
  var dropdowns = document.querySelectorAll('.secondary-nav .dropdown:not(.has-mega-menu)');

  if (!dropdowns.length) {
    return;
  }

  dropdowns.forEach(function (dropdownEl) {
    var toggle = dropdownEl.querySelector('[data-bs-toggle="dropdown"]');
    if (!toggle) {
      return;
    }

    dropdownEl.addEventListener('mouseenter', function () {
      Dropdown.getOrCreateInstance(toggle).show();
    });

    dropdownEl.addEventListener('mouseleave', function () {
      Dropdown.getOrCreateInstance(toggle).hide();
    });
  });
}
